import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';

import { ControlMobileDrawer } from './drawers/ControlMobileDrawer';
import { ControlWebDrawer } from './drawers/ControlWebDrawer';
import { ControlLandscapeDrawer } from './drawers/ControlLandscapeDrawer';
import { GameApplicationType } from '../../core/enums';
import { SOUND_ICON_STATE } from '../../stateManagment';

class ControlDrawer extends DrawerBase {
  constructor(applications) {
    super();
    this.applications = applications;
    this.soundSetupConfig();
  }

  soundSetupConfig() {
    this.addSubscriber(SOUND_ICON_STATE.subscribe(sound => {

    }, true));
  }

  execute(root, mode) {
    this.applications[mode].execute(root);
  }
}

export const controlDrawer = new ControlDrawer({
  [GameApplicationType.web]: new ControlWebDrawer(),
  [GameApplicationType.mobile]: new ControlMobileDrawer(),
  [GameApplicationType.landscape]: new ControlLandscapeDrawer(),
});
